<button
  [class]="'small-action-button ' + buttonClasses"
  [ngClass]="{ 'toggle-on': isToggleButton && toggleState }"
  [attr.id]="buttonId"
  [ngStyle]="buttonStyles"
  [title]="title"
  [type]="buttonType"
  (click)="clickEvent.emit($event)"
  [class.float-right]="floatRight"
  [class.large-icon]="largeIcon"
  [disabled]="disabled"
  *ngIf="display"
>
  <i [ngClass]="'fa' + (icon ? ' fa-' + icon : '')"></i>
  {{ showTitleAsLabel ? title : '' }}
  <ng-content></ng-content>
</button>
